import script from "./PasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordView.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/objects/user/PasswordView.css?vue&type=style&index=0&id=9905ef24&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9905ef24"]])

export default __exports__